import { FlowDurationUnits } from 'flow-schema';

import { api } from 'common';

import { WaitV2FormFields } from './FormFields';
import { waitV2DocumentationMarkdown } from './documentation';
import { CodeMirrorLanguageType } from '../../../../../Code/types';
import { type BlockConfigProps } from '../../../types';

export const waitConfigV2: BlockConfigProps<api.FlowDefinition.WaitBlockV2Config> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'wait',
  defaultConfig: {
    duration: {
      value: 1,
      units: FlowDurationUnits.Minutes,
    },
    waitUntilDate: '',
  },
  configFields: {
    getLanguageFieldValues: (config) => {
      return {
        [CodeMirrorLanguageType.DoubleBraceNodeFields]: [config.waitUntilDate],
      };
    },
    schema: api.FlowDefinition.WaitBlockV2ConfigSchema,
    FormFields: WaitV2FormFields,
  },
  documentationMarkdown: waitV2DocumentationMarkdown,
};
